import { computed, reactive } from 'vue'
import { createSharedComposable } from '@vueuse/core'
import { type AssignmentV2_GetUserAssignmentConversationsResponse_TicketListItem as AssignmentTaskItem } from '@zendesk/zqa-services/assignments_v2'
import type { TicketListItemExt } from '@/modules/conversations/types'
import useTicketRouteParams from '@/composables/useTicketRouteParams'

interface List {
  isLoading: boolean
  items: AssignmentTaskItem[] | TicketListItemExt[]
  total?: string
  type: ListType
}

export enum ListType {
  Assignment = 'assignment',
  Calibration = 'calibration',
}

export default createSharedComposable(() => {
  const { reviewId, conversationId } = useTicketRouteParams()
  const state = reactive<List>({
    isLoading: true,
    items: [],
    total: '0',
    type: ListType.Assignment,
  })

  const isAssignmentsList = computed(() => state.type === ListType.Assignment)
  const isCalibrationsList = computed(() => state.type === ListType.Calibration)

  const selectedAssignmentItem = computed(() => {
    if (!isAssignmentsList.value) return null

    return state.items.find((item) => {
      if (reviewId.value) {
        return item.reviewId === reviewId.value
      }
      return item.externalId === conversationId.value
    }) as AssignmentTaskItem
  })

  return {
    state,
    isAssignmentsList,
    isCalibrationsList,
    selectedAssignmentItem,
  }
})
